var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 487.43 232.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-8e5fa4c5-7ab4-424e-bc09-3a96957874a7, .uuid-670c37c3-ef92-47ee-abb8-a29f9b57fc38 {\n        fill: #099;\n      }\n\n      .uuid-9addebcc-02a0-4f62-a6bb-e81593708330 {\n        fill: #fff;\n      }\n\n      .uuid-76c60fe6-7fff-4377-8b42-fa0b32ac1f39 {\n        isolation: isolate;\n      }\n\n      .uuid-520e58d6-e657-4585-88c0-9d5cfd1e1b87 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 5px;\n      }\n\n      .uuid-375b41ec-bd18-416e-ac43-077939bb44aa {\n        fill: #666;\n        opacity: .06;\n      }\n\n      .uuid-670c37c3-ef92-47ee-abb8-a29f9b57fc38 {\n        opacity: .99;\n      }\n\n      .uuid-670c37c3-ef92-47ee-abb8-a29f9b57fc38, .uuid-64305b53-6d51-46c0-bb4e-3bd012e9106e {\n        mix-blend-mode: multiply;\n      }\n\n      .uuid-b3008fbb-bbb7-4f36-9de8-90c92af798cb {\n        fill: #6cc;\n      }\n\n      .uuid-55cf4a10-b03f-456a-9a3f-0628ca7968dd {\n        fill: #b3e1e1;\n      }\n\n      .uuid-9106a9d9-c313-467c-a882-66330189d500 {\n        fill: #399;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "uuid-76c60fe6-7fff-4377-8b42-fa0b32ac1f39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-7f281f4c-a068-442e-aa95-4cc7f3f25163",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "uuid-375b41ec-bd18-416e-ac43-077939bb44aa",
    cx: 244.43,
    cy: 227,
    rx: 60,
    ry: 5.44
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-55cf4a10-b03f-456a-9a3f-0628ca7968dd",
    d: "m243.43,0l-87.04,29.46v80.73c0,30.74,15.41,59.44,41.04,76.42l45.79,30.33,45.79-30.33c25.63-16.98,41.04-45.68,41.04-76.42V29.46L243.43,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9106a9d9-c313-467c-a882-66330189d500",
    d: "m243.43,12.14l-79.41,23.39v73.84c0,28.12,14.1,54.37,37.54,69.9l41.88,27.74,41.88-27.74c23.44-15.53,37.54-41.78,37.54-69.9V35.52l-79.41-23.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b3008fbb-bbb7-4f36-9de8-90c92af798cb",
    d: "m243.43,195.02l37.08-24.57c20.76-13.75,33.24-37,33.24-61.9V43.17l-70.32-20.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-55cf4a10-b03f-456a-9a3f-0628ca7968dd",
    d: "m243.43,22.46v172.56l-37.08-24.57c-20.76-13.75-33.24-36.99-33.24-61.89V43.17l70.32-20.71Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "uuid-9addebcc-02a0-4f62-a6bb-e81593708330",
    cx: 243.43,
    cy: 99.87,
    rx: 33,
    ry: 32.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-670c37c3-ef92-47ee-abb8-a29f9b57fc38",
    x: 229.26,
    y: 94.96,
    width: 28.34,
    height: 23.04,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("g", {
    className: "uuid-64305b53-6d51-46c0-bb4e-3bd012e9106e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-8e5fa4c5-7ab4-424e-bc09-3a96957874a7",
    d: "m252.89,94.96h-3.53v-4.51c0-3.27-2.66-5.92-5.92-5.92s-5.92,2.66-5.92,5.92v4.51h-3.53v-4.51c0-5.21,4.24-9.45,9.45-9.45s9.45,4.24,9.45,9.45v4.51Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-55cf4a10-b03f-456a-9a3f-0628ca7968dd",
    d: "m427.58,26l-60.15,20.36v55.79c0,21.25,10.65,41.08,28.36,52.81l31.64,20.96,31.64-20.96c17.71-11.73,28.36-31.57,28.36-52.81v-55.79l-59.86-20.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9106a9d9-c313-467c-a882-66330189d500",
    d: "m427.58,34.39l-54.88,16.16v51.03c0,19.43,9.74,37.57,25.94,48.3l28.94,19.17,28.94-19.17c16.2-10.73,25.94-28.87,25.94-48.3v-51.03l-54.88-16.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b3008fbb-bbb7-4f36-9de8-90c92af798cb",
    d: "m427.58,160.77l25.63-16.98c14.34-9.5,22.97-25.57,22.97-42.77v-45.18l-48.6-14.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-55cf4a10-b03f-456a-9a3f-0628ca7968dd",
    d: "m427.58,41.52v119.25l-25.62-16.98c-14.35-9.5-22.97-25.56-22.97-42.77v-45.19l48.59-14.31Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "uuid-9addebcc-02a0-4f62-a6bb-e81593708330",
    cx: 427.58,
    cy: 95.01,
    rx: 22.8,
    ry: 22.71
  })), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9106a9d9-c313-467c-a882-66330189d500",
    d: "m424.85,105.38c-.53,0-1.05-.18-1.43-.51l-7.49-6.43c-.81-.7-.83-1.84-.04-2.56.79-.71,2.09-.73,2.9-.03l5.67,4.87,11.19-15.86c.6-.85,1.86-1.11,2.82-.58.96.53,1.26,1.64.66,2.49l-12.53,17.76c-.33.46-.88.77-1.49.84-.08,0-.17.01-.25.01Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "uuid-375b41ec-bd18-416e-ac43-077939bb44aa",
    cx: 61.93,
    cy: 191.47,
    rx: 40,
    ry: 4.49
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "uuid-375b41ec-bd18-416e-ac43-077939bb44aa",
    cx: 428.35,
    cy: 184.94,
    rx: 40,
    ry: 4.49
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-55cf4a10-b03f-456a-9a3f-0628ca7968dd",
    d: "m61.53,29L0,49.83v57.07c0,21.73,10.89,42.02,29.01,54.02l32.37,21.44,32.37-21.44c18.12-12,29.01-32.29,29.01-54.02v-57.07l-61.23-20.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9106a9d9-c313-467c-a882-66330189d500",
    d: "m61.53,37.58L5.39,54.11v52.19c0,19.88,9.96,38.43,26.53,49.41l29.6,19.61,29.6-19.61c16.57-10.98,26.53-29.53,26.53-49.41v-52.19l-56.14-16.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b3008fbb-bbb7-4f36-9de8-90c92af798cb",
    d: "m61.53,166.85l26.21-17.37c14.67-9.72,23.5-26.15,23.5-43.75v-46.22l-49.71-14.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-55cf4a10-b03f-456a-9a3f-0628ca7968dd",
    d: "m61.53,44.88v121.98l-26.21-17.37c-14.67-9.72-23.5-26.15-23.5-43.75v-46.22l49.71-14.64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-9106a9d9-c313-467c-a882-66330189d500",
    x: 38.93,
    y: 76,
    width: 45,
    height: 9,
    rx: 4.5,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "uuid-520e58d6-e657-4585-88c0-9d5cfd1e1b87",
    cx: 61.82,
    cy: 79.94,
    rx: 6.5,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-9106a9d9-c313-467c-a882-66330189d500",
    x: 39.3,
    y: 94.86,
    width: 45,
    height: 9,
    rx: 4.5,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "uuid-520e58d6-e657-4585-88c0-9d5cfd1e1b87",
    cx: 77.18,
    cy: 99.81,
    rx: 6.5,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-9106a9d9-c313-467c-a882-66330189d500",
    x: 39.3,
    y: 113.86,
    width: 45,
    height: 9,
    rx: 4.5,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "uuid-520e58d6-e657-4585-88c0-9d5cfd1e1b87",
    cx: 47.18,
    cy: 117.81,
    rx: 6.5,
    ry: 6.47
  })), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9addebcc-02a0-4f62-a6bb-e81593708330",
    d: "m245.17,107.85v3.9c0,.96-.78,1.74-1.74,1.74s-1.74-.78-1.74-1.74v-3.9c-1.01-.6-1.68-1.69-1.68-2.94,0-1.89,1.53-3.42,3.42-3.42s3.42,1.53,3.42,3.42c0,1.25-.68,2.35-1.68,2.94Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.005014211fb834c846a5908b71d101d9.svg";
export { ForwardRef as ReactComponent };